import axios from 'axios'
const state = {
    subjects: [],
}
const getters = {
    getSubjects(state) {
        return state.subjects
    },
}
const mutations = {
    setSubjects(state, subjects) {
        state.subjects = subjects
    },
}
const actions = {
    fetchSubjects({ commit },queryParams) {
        return new Promise(async (resolve, reject) => {
            try {
                let params =  {
                        all: true,
                        ...queryParams,
                    };
                if (!queryParams.grade_type_id) {
                    delete params.grade_type_id;
                }
                const subjects = await axios.get("/subject", {
                    params,
                });
                commit('setSubjects', subjects.data.subjects)
                resolve()
            } catch (err) {
                reject()
            } finally {
            }
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true,
}
